<template>
  <v-data-table
    no-data-text="Sem dados"
    :headers="headers"
    :items="items"
    :footer-props="{
      'items-per-page-text': 'Linhas por página',
      'page-text': '{0}-{1} de {2}',
      'items-per-page-all-text': 'Todos',
    }"
    :item-class="cursorPointer"
    @click:row="selecionarSolicitante"
  >
    <template #item.nome="{ item }">
      <div class="d-flex align-center">
        <v-avatar
          :color="`${$vuetify.theme.dark ? 'primary' : '#DCDCDC'}`"
          size="32"
        >
          <span :class="`${$vuetify.theme.dark ? 'white--text' : 'primary--text'} font-weight-bold`">
            {{ item.nome.toUpperCase().charAt(0) }}{{ item.nome.toUpperCase().charAt(1) }}
          </span>
        </v-avatar>

        <div class="d-flex flex-column ms-3">
          {{ item.nome }}
        </div>
      </div>
    </template>

    <template #item.celular="{ item }">
      <span>{{ functions.formatarCelular(item.celular) }}</span>
    </template>

    <template #item.cpf="{ item }">
      <span>{{ functions.maskCpf(item.cpf) }}</span>
    </template>
  </v-data-table>
</template>

<script>
import { formatarCelular } from '@/utils/formatting'
import { maskCpf } from '@/utils/validation'

export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
    selecionarSolicitante: {
      type: Function,
      required: true,
    },
  },

  setup() {
    const headers = [
      { text: 'Id', value: 'id' },
      { text: 'Nome', value: 'nome' },
      { text: 'E-mail', value: 'email' },
      { text: 'Celular', value: 'celular' },
      { text: 'CPF', value: 'cpf' },
    ]

    return {
      headers,
      functions: { formatarCelular, maskCpf },
      cursorPointer: () => 'cursor-pointer',
    }
  },
}
</script>
